import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { timeZoneMap } from "@web-app/utils/helpers";

export default function FilterDateTimeTz({
  start,
  end,
  timezone,
  isDateRange,
}: {
  end: Date;
  isDateRange?: boolean;
  start: Date;
  timezone: keyof typeof timeZoneMap;
}) {
  return (
    <span className="">
      <FormattedFilterTime
        start={start}
        end={end}
        isDateRange={isDateRange}
        timezone={timezone}
      />
    </span>
  );
}

const FormattedFilterTime = ({
  start,
  end,
  isDateRange,
  timezone,
}: {
  end: Date;
  isDateRange?: boolean;
  start: Date;
  timezone?: keyof typeof timeZoneMap;
}) => {
  const { getTimezone } = useTimezone();

  const effectiveTimezone = getTimezone(timezone);

  if (isDateRange) {
    const startDate =
      effectiveTimezone === "system"
        ? dayjs(start).format("MM/DD/YYYY")
        : dayjs.utc(start).tz(effectiveTimezone).format("MM/DD/YYYY");

    const endDate =
      effectiveTimezone === "system"
        ? dayjs(end).format("MM/DD/YYYY")
        : dayjs.utc(end).tz(effectiveTimezone).format("MM/DD/YYYY");

    return (
      <>
        {startDate} <br /> - {endDate}
      </>
    );
  }

  const dateFormatted =
    effectiveTimezone === "system"
      ? dayjs(start).format("MM/DD/YYYY")
      : dayjs.utc(start).tz(effectiveTimezone).format("MM/DD/YYYY");

  const startTime =
    effectiveTimezone === "system"
      ? dayjs(start).format("h:mm A")
      : dayjs.utc(start).tz(effectiveTimezone).format("h:mm A");

  const endTime =
    effectiveTimezone === "system"
      ? dayjs(end).format("h:mm A")
      : dayjs.utc(end).tz(effectiveTimezone).format("h:mm A");

  return (
    <>
      {dateFormatted}
      <br />
      {startTime} - {endTime}
    </>
  );
};
